var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2465 2.50473C12.7832 1.7892 13.7297 1.51696 14.5645 1.83804L19.4372 3.71218C20.4591 4.1052 20.975 5.24681 20.5948 6.2735L15.6017 19.7547C14.846 19.503 14.1189 19.2501 13.3125 19.2501C12.5419 19.2501 11.81 19.4507 11.3283 20.0632L9.56623 23.0001H2.27686L5.10481 18.0511C5.1342 17.9741 5.2216 17.7005 5.19099 17.3331C5.15288 16.8758 4.92603 16.1215 3.87534 15.2809L3.11849 14.6754L12.2465 2.50473ZM7.18408 17.167C7.13755 16.6086 6.96591 15.992 6.59392 15.3616L11.3531 17.616C10.7574 17.864 10.1758 18.2657 9.70004 18.9001L9.06694 19.9501L6.30263 19.9861L6.88205 18.9721C7.15585 18.4245 7.23434 17.7701 7.18408 17.167ZM7.95561 11.5593L6.71913 13.2079L14.5244 16.9051L15.2284 15.0043L7.95561 11.5593ZM9.1803 9.92637L15.9257 13.1216L18.7193 5.57887L13.8465 3.70473L9.1803 9.92637Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaint);
export default __webpack_public_path__ + "static/media/paint.43c59b67.svg";
export { ForwardRef as ReactComponent };